import axios from 'axios'
import { PRICE_VERSION_VARIATION_DRAFT_BY_PRICE_DETAIL } from '../../endpoints'

export async function getDraftByPriceDetail({rowSelected, selectedOption}){
    try{
        let {
            datamasterId,
            modelId,
            selectedNewPrice = Number(selectedNewPrice.replaceAll('.','')),
            year
        } = rowSelected
        let oneVersion = selectedOption.option == 'oneVersion' ?  true : false        
        const response = await axios.get(`${PRICE_VERSION_VARIATION_DRAFT_BY_PRICE_DETAIL}/${datamasterId}?modelId=${modelId}&price=${selectedNewPrice}&year=${year}&oneVersion=${oneVersion}`).then(result=>result.data);
        return {
            dataForTable: response.data,
            yearsForTable: response.years,
            modelVersionPrice: response.modelVersionPrice
        }
    }catch(error){
        console.log(error)
        throw new Error(error)
    }
}